import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import { WEBAPP_ROUTE_PREFIX } from '../../../constants/route'
import {
  useIsExternalContactProfileNGAvailable,
  useIsProviderProfileNGAvailable,
  useIsUserProfileNGAvailable,
  useLinkLikeClick,
} from '../../../hooks'
import { getUserProfileRoute } from '../../../utils/user'
import { UserListItem } from '../../ListItem'

import { isNeedToShowUserItemIcons } from './ProfileUsersWidgetItem.utils'
import { ProfileUsersWidgetItemContent } from './ProfileUsersWidgetItemContent'

import * as styles from './ProfileUsersWidgetItem.module.css'

function ProfileUsersWidgetItem({
  Content = ProfileUsersWidgetItemContent,
  blocked,
  className = styles.ProfileUsersWidgetItem,
  hoverClassName = styles.hover,
  isNeedToShowIcons = isNeedToShowUserItemIcons,
  tooltipProps = {
    placement: FLOATING_ELEMENT_PLACEMENT.top,
  },
  ...restProps
}) {
  const { handleClick } = useLinkLikeClick()

  const isExternalContactProfileNGAvailable =
    useIsExternalContactProfileNGAvailable()
  const isProviderProfileNGAvailable = useIsProviderProfileNGAvailable()
  const isUserProfileNGAvailable = useIsUserProfileNGAvailable()

  function handleClickParticipant({ id, role }) {
    const link = getUserProfileRoute({
      id,
      isExternalContactProfileNGAvailable,
      isProviderProfileNGAvailable,
      isUserProfileNGAvailable,
      role,
    })

    handleClick({
      link,
      // Webapp fallback keeps opening in a new tab; NG profiles navigate in-app.
      outsideLink: link.includes(WEBAPP_ROUTE_PREFIX),
    })
  }

  return (
    <UserListItem
      {...restProps}
      Content={Content}
      blocked={blocked}
      className={className}
      hoverClassName={hoverClassName}
      isNeedToShowIcons={isNeedToShowIcons}
      tooltipProps={tooltipProps}
      onClick={handleClickParticipant}
    />
  )
}

export default ProfileUsersWidgetItem
